export default "__VITE_ASSET__DL$ibqz2__"